import _filter from 'lodash/filter';
import { useMemo } from 'react';
import { useGetSimplifiedNavigation } from '../../../hooks/useGetSimplifiedNavigation';
import type { Navigation, NavigationItem } from '../../../types';
import { getActivePathnames } from '../../../utils';
import { getActiveNavItem } from '../../SideNavigation/helpers';

interface UseBottomNavItemsProps {
  navigation: Navigation;
  pathname: string;
  projectSlug?: string;
}

export function useBottomNavItems({ navigation: _navigation, pathname, projectSlug }: UseBottomNavItemsProps) {
  const activePathnames = useMemo(
    () => getActivePathnames(pathname, projectSlug),
    [pathname, projectSlug],
  );

  const navigation = useGetSimplifiedNavigation(_navigation);

  const otherPrimaryNavItems = useMemo(
    () => navigation.primary.filter((item) => item.id !== 'BRAND_NAVIGATION'),
    [navigation.primary],
  );

  // Currently, remove all navItems with type GROUP and USER_MENU
  // Also dont render secondary navItems for bottom nav
  const adaptedNavItems = useMemo(
    () =>
      _filter(
        otherPrimaryNavItems,
        (item: NavigationItem) => item.type !== 'GROUP' && item.type !== 'USER_MENU',
      ),
    [otherPrimaryNavItems],
  );

  const hasActiveNavItem = useMemo(
    () => Boolean(getActiveNavItem({ navItems: adaptedNavItems, activePathnames })),
    [adaptedNavItems, activePathnames],
  );

  return { activePathnames, adaptedNavItems, hasActiveNavItem };
}
